import { env } from '@/env'
import { client as heyApiClient } from '../client/client.gen'

/**
 * Configure the hey-api client with environment-based settings
 * This should be called once during app initialization
 */
export function configureHeyApiClient() {
  heyApiClient.setConfig({
    baseUrl: env.VITE_API_URL || '/api',
  })
}

/**
 * Get the configured hey-api client instance
 */
export { heyApiClient }
